// ============================================
// Detail Module - State (Zustand 기반)
// ============================================

import { useHomeStore } from '../../../stores/homeStore.js';
import { getMyPageWorks } from '../../mypage/state.js';

// ============================================
// Getters
// ============================================

export function getSelectedContent() {
  return useHomeStore.getState().selectedContentForDetail;
}

export function getAllPublishedContent() {
  const cache = useHomeStore.getState().publishedContentCache;
  return [...(cache.character || []), ...(cache.story || [])];
}

export { getMyPageWorks };

export function getDb() {
  return useHomeStore.getState().getDb();
}

export function getPublishedCache() {
  return useHomeStore.getState().publishedContentCache;
}

export function getIsLikeProcessing() {
  return useHomeStore.getState().isLikeProcessing;
}

// ============================================
// Setters
// ============================================

export function setSelectedContent(content) {
  useHomeStore.getState().setSelectedContent(content);
}

export function setIsLikeProcessing(val) {
  useHomeStore.getState().setIsLikeProcessing(val);
}
